import {
  Body,
  Box,
  BoxProps,
  Button,
  Heading,
  Icon,
  Link,
  LinkProps,
  TextInput,
  VStack,
} from '@hover/blueprint';
import { iArrowRight } from '@hover/icons';
import React from 'react';
import { useForm } from 'react-hook-form';
import { HOVER_DOWNLOAD_APP_LINK } from '../../../constants';

const VALIDATION = /^(()?\d{3}())?(-|\s)?\d{3}(-|\s)?\d{4}$/;

interface Props extends BoxProps {
  inputBackground?: string;
  contentColor?: string;
  inputColor?: string;
  linkColorScheme?: LinkProps['colorScheme'];
}

const SignUpCTAForm: React.FC<Props> = ({
  inputBackground,
  contentColor,
  inputColor,
  linkColorScheme,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm();

  const getDashedValue = (): string => {
    const { phoneNumber } = watch();
    if (phoneNumber && typeof phoneNumber === 'string') {
      const numWithoutDashes = phoneNumber.replace(/[^0-9]/g, '');
      const numLength = numWithoutDashes.length;
      if (numLength) {
        if (numLength > 0 && numLength < 4) {
          return `${numWithoutDashes.slice(0, 3)}`;
        }
        if (numLength > 3 && numLength < 7) {
          return `${numWithoutDashes.slice(0, 3)}-${numWithoutDashes.slice(
            3,
            6,
          )}`;
        }
        if (numLength > 6) {
          return `${numWithoutDashes.slice(0, 3)}-${numWithoutDashes.slice(
            3,
            6,
          )}-${numWithoutDashes.slice(6)}`;
        }
      }
      return '';
    }
    return '';
  };

  const onSubmit = () => {};

  return (
    <Box pt={300} alignItems="flex-start">
      <Box
        py={300}
        px={400}
        bg={inputBackground}
        alignItems="center"
        borderRadius="4px"
        mr={200}
      >
        <>🇺🇸</>
        <Heading ml={200} size={200} marginBottom={0}>
          +1
        </Heading>
      </Box>
      <VStack mr={400} spacing="10px" w="134px">
        <TextInput
          bg={inputBackground}
          {...register('phoneNumber', {
            required: 'error message',
            pattern: VALIDATION,
          })}
          value={getDashedValue()}
          borderColor="neutral.0"
          color={inputColor}
          fontWeight={400}
        />
        {errors?.phoneNumber ? (
          <Body size={300} color="danger.300" maxW="188px" alignSelf="center">
            Please enter a U.S. phone number in the correct format. All numbers,
            no dashes.
          </Body>
        ) : null}
      </VStack>
      <VStack maxW="252px" spacing={300} alignItems="flex-start">
        <Button onClick={handleSubmit(onSubmit)} size="large" pr={500}>
          <Heading size={200} color="neutral.0">
            Try It on Your home
          </Heading>
          <Icon
            m={0}
            ml={200}
            icon={iArrowRight}
            size="default"
            color="neutral.0"
          />
        </Button>
        <Body size={300} color={contentColor} maxW="188px" alignSelf="center">
          We’ll text you a link to download&nbsp;
          <Link
            colorScheme={linkColorScheme}
            href={HOVER_DOWNLOAD_APP_LINK}
            textDecorationColor="currentColor"
          >
            our app
          </Link>
          . We won’t contact you for any other reason.
        </Body>
      </VStack>
    </Box>
  );
};

SignUpCTAForm.defaultProps = {
  inputBackground: 'neutral.0',
  contentColor: 'neutral.0',
  inputColor: 'brandNavy.300',
  linkColorScheme: 'neutral',
};

export default SignUpCTAForm;
